module.exports = {
          srcSet: __webpack_public_path__ + "images/2021-2-f2e5cd2a3bc1a0806e26d8f84d630176-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/2021-2-e1d68b681dd0b7d9ed4dc72cf8f0df0e-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/2021-2-f2e5cd2a3bc1a0806e26d8f84d630176-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/2021-2-e1d68b681dd0b7d9ed4dc72cf8f0df0e-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/2021-2-f2e5cd2a3bc1a0806e26d8f84d630176-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/2021-2-f2e5cd2a3bc1a0806e26d8f84d630176-320.jpg"},
          
          width: 320,
          height: 251
        }